import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectGrantRewardsInfo } from "../../../selectors/selectGrantRewardsInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { DialogWrapper } from "../../dialog/DialogWrapper";
import { ButtonPrimary } from "../../generic/common/ButtonPrimary";
import { TextLoca } from "../../generic/text/TextLoca";
import { RewardStoreResources } from "../../store/RewardStoreResources";
import { actionFortuneTellerEventCollect } from "../actionFortuneTellerEventInfo";
var _DialogCollectReward = function (_a) {
    var rewards = _a.rewards, onCollect = _a.onCollect;
    if (!rewards) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.fortuneTellerEvent_reward_title, className: IdStyles.ModalBackgroundLevelUp, onClose: onCollect },
        React.createElement("div", { className: "flex flex--guts flex--stacked w100 h100" },
            React.createElement(RewardStoreResources, { rewards: rewards, backgroundClassName: IdStyles.TraderEventRewardImageBackground }),
            React.createElement("div", { className: "button-ribbon" },
                React.createElement(ButtonPrimary, { onClick: onCollect },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.collect }))))));
};
var mapState = function (state) {
    return {
        rewards: selectGrantRewardsInfo(state),
    };
};
var mapDispatch = function (dispatch) { return ({
    onCollect: function () { return dispatch(actionFortuneTellerEventCollect()); },
}); };
export var DialogCollectReward = connect(mapState, mapDispatch)(_DialogCollectReward);



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/components/DialogCollectReward.tsx
// module id = 2834
// module chunks = 3